// 64 × 64 = 4,096 combinations.

export const ADJECTIVES = [
  'しずか','あかるい','くらい','あさい','ふかい','ひろい','せまい','たかい',
  'ひくい','ながい','みじかい','ほそい','ふとい','まるい','はやい','おそい',
  'つよい','よわい','かるい','おもい','やわらか','かたい','あたたか','すずしい',
  'つめたい','あつい','さむい','あかい','あおい','みどり','くろい','しろい',
  'きいろ','むらさき','もも','こがね','しろがね','こはく','るり','ひすい',
  'さんご','ぎん','かすか','さやか','おぼろ','ひかる','かがやく','しなやか',
  'すずやか','あざやか','ほのか','たおやか','うるわしい','まばゆい','すこやか','ささやか',
  'ひそか','ほがらか','のどか','ゆたか','なつかしい','きよらか','うつくしい','さわやか',
]

export const NOUNS = [
  'つき','ほし','そら','くも','かぜ','あめ','ゆき','にじ',
  'あらし','きり','つゆ','しも','かみなり','あかつき','たそがれ','しぐれ',
  'やま','うみ','かわ','もり','たに','しま','いし','すな',
  'たき','おか','はら','だんがい','さくら','うめ','まつ','たけ',
  'もみじ','はす','きく','ゆり','すみれ','あやめ','ふじ','つつじ',
  'とり','すずめ','つばめ','うぐいす','はと','わし','たか','からす',
  'さぎ','つる','おおかみ','きつね','うさぎ','しか','くま','りす',
  'ひ','なみ','いずみ','こだま','いなほ','ほのお','たま','かげ',
]
